import axios from 'axios'
import store from '@/store'
import {
  getGroupAuthorization,
  removeGroupAuthorization,
  setGroupAuthorization
} from './auth'

const groupAxios = axios.create({
  timeout: 60000,
  baseURL: '/api'
})

const token = getGroupAuthorization()
if (token) {
  groupAxios.defaults.headers.common.Authorization = token
}

function isGroupApi (url, api) {
  return (url || '').replace(/^\/api\//, '').replace(/^\//, '') === api
}

groupAxios.interceptors.request.use(function (config) {
  if (isGroupApi(config.url, 'auth/oauth/login')) {
    config.auth = {
      username: 'H5',
      password: 'H5'
    }
  }
  if (isGroupApi(config.url, 'auth/removeToken')) {
    removeGroupAuthorization()
    delete groupAxios.defaults.headers.common.Authorization
    store.commit('group/setUserInfo', null)
  } else if (!isGroupApi(config.url, 'auth/oauth/login')) {
    const authorization = getGroupAuthorization()
    if (authorization) {
      config.headers.Authorization = authorization
    }
  }
  return config
}, function (error) {
  return Promise.reject(error)
})

groupAxios.interceptors.response.use(function (response) {
  const { config, data } = response
  if (isGroupApi(config.url, 'auth/oauth/login') && data.errCode === 0) {
    const authorization = `Bearer ${data.data.value}`
    groupAxios.defaults.headers.common.Authorization = authorization
    setGroupAuthorization(authorization, data.data.expiration)
    return data
  }
  if (data.errCode === 100002) {
    removeGroupAuthorization()
    delete groupAxios.defaults.headers.common.Authorization
    store.commit('group/setUserInfo', null)
  }
  if (data.errCode && data.errCode !== 0) {
    alert(data.msg)
  }
  return data
}, function (error) {
  if (error.response) {
    switch (error.response.status) {
      case 401:
        removeGroupAuthorization()
        delete groupAxios.defaults.headers.common.Authorization
        store.commit('group/setUserInfo', null)
        break
      case 400:
        alert('请检查参数是否正确')
        break
      case 404:
        alert('接口地址未找到')
        break
      case 500:
        alert('服务器繁忙')
        break
      default:
        alert('网络异常')
    }
  }
  return Promise.reject(error)
})

export function get (url, params) {
  return groupAxios.get(url, { params }).catch((error) => {
    console.log(error)
  })
}

export function post (url, data, config = {}) {
  return groupAxios.post(url, data, config).catch((error) => {
    console.log(error)
  })
}



// WEBPACK FOOTER //
// ./src/group/utils/http.js